<template>
  <div>
    <div v-for="(item,index) in Array.from(new Set(value?.split(','))).slice(0,2)" :key="index">{{item}}</div>
    <a-popover v-if="Array.from(new Set(value?.split(','))).length>2" placement="right" trigger="click">
      <template slot="content">
        <div style="width: 325px;">
          <a-tag class="box-show-tag" v-for="(item,index) in Array.from(new Set(value?.split(',')))" :key="index">{{item}}</a-tag>
        </div>
      </template>
      <a>{{$t('all')}}</a>
    </a-popover>

  </div>
</template>

<script>
export default {
  name: "showCode",
  props: {
    value: {type: String, default: null},
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.box-show-tag{
  margin: 4px 5px;
}

</style>